import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CrownIcon, SaveIcon, CheckCircleIcon } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import { TIER_CONFIGS } from '../../lib/mockData';
import type { TierConfig } from '../../lib/types';
export function TiersPage() {
  const [tiers, setTiers] = useState<TierConfig[]>([...TIER_CONFIGS]);
  const [saved, setSaved] = useState(false);
  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };
  const updateTier = (index: number, key: keyof TierConfig, value: number | boolean) => {
    setTiers(prev => prev.map((t, i) => i === index ? {
      ...t,
      [key]: value
    } : t));
  };
  return <div data-id="element-1025">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-1026">
        <h1 className="text-2xl font-bold text-white mb-1 flex items-center gap-3" data-id="element-1027">
          <CrownIcon className="w-7 h-7 text-[#C8A84E]" data-id="element-1028" />
          Hạng Thành Viên
        </h1>
        <p className="text-sm text-[#666666] mb-6" data-id="element-1029">
          Cấu hình hạng và quyền lợi thành viên
        </p>
      </motion.div>

      {saved && <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-4 bg-[#22C55E]/10 border border-[#22C55E]/20 rounded-xl p-3 flex items-center gap-2" data-id="element-1030">
          <CheckCircleIcon className="w-4 h-4 text-[#22C55E]" data-id="element-1031" />
          <span className="text-sm text-[#22C55E]" data-id="element-1032">Đã lưu cài đặt!</span>
        </motion.div>}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1033">
        {tiers.map((tier, i) => <motion.div key={tier.level} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: i * 0.05
      }} data-id="element-1034">
            <Card data-id="element-1035">
              <div className="flex items-center gap-3 mb-4" data-id="element-1036">
                <span className="text-2xl" data-id="element-1037">{tier.icon}</span>
                <div data-id="element-1038">
                  <h3 className="font-semibold text-white" data-id="element-1039">{tier.nameVi}</h3>
                  <Badge variant="tier" tier={tier.level} size="sm" data-id="element-1040">
                    {tier.name}
                  </Badge>
                </div>
              </div>
              <div className="space-y-3" data-id="element-1041">
                <Input label="Điểm tối thiểu" type="number" value={tier.minPoints.toString()} onChange={e => updateTier(i, 'minPoints', parseInt(e.target.value) || 0)} data-id="element-1042" />
                <Input label="Giảm giá hóa đơn (%)" type="number" value={tier.discountPercent.toString()} onChange={e => updateTier(i, 'discountPercent', parseFloat(e.target.value) || 0)} data-id="element-1043" />
                <Input label="Hệ số điểm" type="number" value={tier.pointMultiplier.toString()} onChange={e => updateTier(i, 'pointMultiplier', parseFloat(e.target.value) || 0)} data-id="element-1044" />
                <div className="flex gap-4" data-id="element-1045">
                  <label className="flex items-center gap-2 text-sm text-[#B0B0B0]" data-id="element-1046">
                    <input type="checkbox" checked={tier.hasBirthdayGift} onChange={e => updateTier(i, 'hasBirthdayGift', e.target.checked)} className="rounded border-[#2A2A2A] bg-[#141414] text-[#C8A84E] focus:ring-[#C8A84E]" data-id="element-1047" />
                    Quà sinh nhật
                  </label>
                  <label className="flex items-center gap-2 text-sm text-[#B0B0B0]" data-id="element-1048">
                    <input type="checkbox" checked={tier.hasExclusivePromos} onChange={e => updateTier(i, 'hasExclusivePromos', e.target.checked)} className="rounded border-[#2A2A2A] bg-[#141414] text-[#C8A84E] focus:ring-[#C8A84E]" data-id="element-1049" />
                    Ưu đãi riêng
                  </label>
                </div>
              </div>
            </Card>
          </motion.div>)}
      </div>

      <div className="mt-6 flex justify-end" data-id="element-1050">
        <Button onClick={handleSave} data-id="element-1051">
          <SaveIcon className="w-4 h-4" data-id="element-1052" />
          Lưu Cài Đặt
        </Button>
      </div>
    </div>;
}